var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { navigate, requireToken } from '../../../utility/general';
import { getJson } from '../../../utility/request';
import { discountRate } from '../../../utility/calculations';
const MSA_APPLICATION_URL = 'https://na2.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhCIaMc64Vmg9ENLWqwJ1R3oA3XcK6GrUFc5c2IB9mkuBXyWrjnw98NJMYgGtKeF_yg*&hosted=false';
// Adobe Sign web form pre-fill: hash-fragment params, format `#Field1=value1&Field2=value2`.
// Each Adobe field has "Default value may come from URL" enabled in the form authoring view.
const buildMSAPrefillURL = (merchant) => {
    const dr = discountRate(merchant.non_cash_rate);
    const fields = [
        ['BusinessName', merchant.business_name],
        ['DBAaddress', merchant.address],
        ['DBAcity', merchant.city],
        ['State', merchant.state],
        ['Zip', merchant.zip],
        ['ContactName', merchant.contact_name],
        ['OwnerName1', merchant.contact_name],
        ['DBAphone', merchant.phone],
        ['MerchantEmail', merchant.email],
        ['DiscountRate', dr],
    ];
    const hash = fields
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
        .join('&');
    return hash ? `${MSA_APPLICATION_URL}#${hash}` : MSA_APPLICATION_URL;
};
export default (props) => {
    // requireToken is a hook (calls useToken internally) — must be called at the
    // top of the component body, not inside an async/effect closure.
    const token = requireToken('merchant');
    const [merchant, setMerchant] = useState(null);
    useEffect(() => {
        if (!props.view.createMSAApplication) {
            setTimeout(() => {
                navigate('/#/');
            }, 10000);
            return;
        }
        // The page is still useful without pre-fill data; on fetch failure fall back
        // to the bare URL so the button still works.
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const value = (yield getJson(`/merchants/${token.merchant.id}`));
                setMerchant(value);
            }
            catch (e) {
                console.warn('subscription-payment-success: merchant fetch failed; pre-fill disabled', e);
            }
        }))();
    }, []);
    const msaURL = merchant ? buildMSAPrefillURL(merchant) : MSA_APPLICATION_URL;
    return (_jsx("div", { className: "d-flex flex-column gap-5 justify-content-center", children: _jsxs("div", { className: "bg-white rounded-4 p-5 shadow text-center", children: [_jsx("h1", { children: "Thank You" }), !props.view.createMSAApplication ? (_jsxs("p", { children: ["Thank you for subscribing to the ", props.view.plan, " plan. You will automatically be redirected to the dashboard in 10 seconds.", _jsx("br", {}), "If you are not redirected, please click ", _jsx("a", { href: "/#/", children: "here" }), "."] })) : (_jsxs(_Fragment, { children: [_jsxs("p", { className: "mb-4", children: ["Thank you for subscribing to the ", props.view.plan, " plan."] }), _jsxs("div", { className: "row align-items-center gap-3", children: [_jsx("div", { className: "col-12 row justify-content-center", children: _jsxs("a", { className: "btn btn-primary col-6 d-inline-flex align-items-center justify-content-center gap-2", href: msaURL, target: "_blank", rel: "noreferrer", children: ["Open Merchant Service Account Application", _jsx("span", { className: "material-symbols-outlined", style: { fontSize: '1.1em' }, children: "open_in_new" })] }) }), _jsx("div", { className: "col-12 row justify-content-center", children: _jsx("button", { type: "button", className: "btn btn-primary col-6", onClick: () => navigate('/#/'), children: "Go to Dashboard" }) })] })] }))] }) }));
};
